/* Pleine Bull — page d'accueil (sections pb-home-*) */
(function () {
  if (window.__pbHomeInit) return;
  window.__pbHomeInit = true;

  /* ---------- Conseiller "3 clics" ---------- */
  function initFinder(root) {
    var btn = root.querySelector('[data-pbh-finder-go]');
    if (!btn) return;
    function value(name) {
      var el = root.querySelector('input[name="' + name + '"]:checked');
      return el ? el : null;
    }
    function update() {
      var jeu = value('pbh-jeu');
      var niveau = value('pbh-niveau');
      var budget = value('pbh-budget');
      if (!jeu) return;
      var url = jeu.getAttribute('data-url') || '/collections/all';
      var params = [];
      if (niveau && niveau.value) {
        niveau.value.split(',').forEach(function (n) {
          params.push('filter.p.m.custom.niveau_joueur=' + encodeURIComponent(n.trim()));
        });
      }
      if (budget) {
        var min = budget.getAttribute('data-min');
        var max = budget.getAttribute('data-max');
        if (min) params.push('filter.v.price.gte=' + min);
        if (max) params.push('filter.v.price.lte=' + max);
      }
      btn.href = url + (params.length ? (url.indexOf('?') > -1 ? '&' : '?') + params.join('&') : '');
      var label = btn.getAttribute('data-label') || 'Voir les fléchettes';
      var txt = label + ' ' + (jeu.getAttribute('data-short') || '');
      if (budget) txt += ' · ' + (budget.getAttribute('data-short') || '');
      btn.textContent = txt;
    }
    root.addEventListener('change', update);
    update();

    /* Avant d'y aller : si la combinaison ne donne aucun produit, on élargit (niveau, puis budget). */
    function countProducts(url) {
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[id*="__product-grid"]') || doc.querySelector('main');
        if (!grid) return 1;
        var seen = {};
        grid.querySelectorAll('a[href*="/products/"]').forEach(function (a) { seen[a.getAttribute('href').split('?')[0]] = 1; });
        return Object.keys(seen).length;
      }).catch(function () { return 1; });
    }
    function withoutParam(url, name) {
      var u = new URL(url, window.location.origin);
      Array.from(u.searchParams.keys()).forEach(function (k) { if (k.indexOf(name) === 0) u.searchParams.delete(k); });
      return u.pathname + (u.search || '');
    }
    btn.addEventListener('click', function (e) {
      if (btn.getAttribute('data-checked') === btn.href) return;
      e.preventDefault();
      var target = btn.href;
      var label = btn.textContent;
      btn.textContent = 'Recherche en cours…';
      btn.setAttribute('aria-busy', 'true');
      countProducts(target).then(function (n) {
        if (n > 0) return target;
        var relaxed = withoutParam(target, 'filter.p.m.custom.niveau_joueur');
        return countProducts(relaxed).then(function (n2) {
          return n2 > 0 ? relaxed : withoutParam(relaxed, 'filter.v.price');
        });
      }).then(function (finalUrl) {
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        window.location.href = finalUrl;
      });
    });
  }

  /* ---------- Flèches des rangées ---------- */
  function initRail(root) {
    var rail = root.querySelector('[data-pbh-rail]');
    var prev = root.querySelector('[data-pbh-prev]');
    var next = root.querySelector('[data-pbh-next]');
    if (!rail || !prev || !next) return;
    function step() { return Math.max(rail.clientWidth * 0.8, 220); }
    function sync() {
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- Ajout au panier (même mécanique que le thème : tiroir panier + compteur) ---------- */
  function htmlOf(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pbh-add]');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-pbh-add'), 10);
    if (!id) return;
    var items = [{ id: id, quantity: 1 }];
    var store = window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper');
    if (store && typeof store.addItems === 'function') { store.addItems(items); return; }

    var drawer = document.getElementById('CartDrawer');
    var drawerId = drawer && drawer.dataset ? drawer.dataset.sectionId : null;
    var sections = ['cart-icon-bubble'];
    if (drawerId) sections.push(drawerId);
    btn.setAttribute('aria-busy', 'true');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sections })
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.removeAttribute('aria-busy');
      if (res.status && res.status >= 400) { window.location.href = btn.closest('.pbh-card').querySelector('a').href; return; }
      var s = res.sections || {};
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && s['cart-icon-bubble']) {
        var b = htmlOf(s['cart-icon-bubble'], '.shopify-section') || htmlOf(s['cart-icon-bubble'], '#cart-icon-bubble');
        if (b != null) bubble.innerHTML = b;
      }
      if (drawer && drawerId && s[drawerId]) {
        var d = htmlOf(s[drawerId], '#CartDrawer');
        if (d != null) drawer.innerHTML = d;
        document.dispatchEvent(new CustomEvent('maximize:cart:updated', { detail: { openMiniCart: true } }));
        try { drawer.isOpen = true; } catch (err) {}
        document.dispatchEvent(new CustomEvent('cart:minicart:open'));
      } else {
        window.location.href = '/cart';
      }
    }).catch(function () { btn.removeAttribute('aria-busy'); window.location.href = '/cart'; });
  });

  /* ---------- Parties en direct de l'appli ---------- */
  function initFeed(root) {
    var list = root.querySelector('[data-pbh-feed]');
    if (!list) return;
    var url = list.getAttribute('data-pbh-feed');
    if (!url) return;
    function clean(s) {
      return String(s || '').trim().toLowerCase().replace(/(^|[\s&])\S/g, function (c) { return c.toUpperCase(); });
    }
    function mode(s) {
      var base = String(s || '').trim().toUpperCase().replace(/\s*\(.*?\)\s*$/, '');
      if (!base) return 'Partie';
      if (/^\d+$/.test(base)) return base;
      return base.toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
    }
    fetch(url).then(function (r) { return r.ok ? r.json() : []; }).then(function (games) {
      if (!games || !games.length) return;
      var seen = [];
      for (var i = 0; i < games.length && seen.length < 4; i++) {
        var key = clean(games[i].winner) + '|' + mode(games[i].mode);
        if (seen.length && seen[seen.length - 1].key === key) continue;
        seen.push({ key: key, name: clean(games[i].winner), mode: mode(games[i].mode) });
      }
      list.textContent = '';
      seen.forEach(function (g) {
        var li = document.createElement('li');
        var a = document.createElement('span'); a.textContent = g.name;
        var b = document.createElement('span'); b.textContent = g.mode;
        li.appendChild(a); li.appendChild(b); list.appendChild(li);
      });
    }).catch(function () {});
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pbh-finder]').forEach(initFinder);
    (scope || document).querySelectorAll('[data-pbh-rail-wrap]').forEach(initRail);
    (scope || document).querySelectorAll('[data-pbh-app]').forEach(initFeed);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Éditeur de thème : réinitialise une section quand on la modifie */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
